define('views/modules/template/template-panel',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/viewport',
    // views
    'views/parts/panel/base-panel',
    'views/modules/template/custom/custom-content',
    //'views/modules/template/shared/shared-content'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    Viewport,
    // views
    VBasePanel,
    VCustomContent
    //VSharedContent
) {

    var VTemplatePanel = VBasePanel.extend({
        header: {
            title: "Templates",
            subtitle: "Create or load template",
        },

        tabs: [{ id: 'custom', route: '#', title: 'Custom', icon: 'sl-icon-settings', active: true, }],
        content: {
            custom: VCustomContent,
            //shared: VSharedContent,
        },
        defaultView: 'custom',

        initialize: function(opt) {
            opt = opt || {};
            var customView = this.getView('custom');
            this.listenTo(customView, { 'template:edit': this.onTemplateEdit });
            this.listenTo(customView, { 'template:add': this.onTemplateAdd });
        },

        getContentViewOptions: function(options) {
            return _.extend({
                model: this.model,
            }, this.options);
        },

        onTemplateEdit: function() {
            if (Viewport.isMobile()) this.close();
        },

        onTemplateAdd: function() {
            if (Viewport.isMobile()) this.close();
        },

    });

    return VTemplatePanel;
});

